import React from "react";

export default class Page extends React.Component {
  constructor(props) {
    super(props);
  }

  render() {
    let style = {};
    if (this.props.backgroundImageUrl) {
      style.backgroundImage = "url(" + this.props.backgroundImageUrl + ")";
    }

    let name = this.props.topic;
    if (!name) {
      name = null;
    }

    return (
      <div className="page" style={style}>
        <div className="background"></div>
        <div className="inner">
          <div className="container">
            {name}
            {this.props.children}
          </div>
        </div>
      </div>
    );
  }
}
